var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"news"},domProps:{"innerHTML":_vm._s(_vm.news)}})
}
var staticRenderFns = []

export { render, staticRenderFns }